var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('apexchart',{attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }